export default [
    {
      path: '/manage-lottery-results',
      component: () => import('@/admin/pages/ManageLotteryResults'),
      name: 'ManageLotteryResults',
    }
]
